

export class DeviceBrandOutputWithStatus implements IDeviceBrandOutputWithStatus {
    /** The auto-generated id of the device brand  master */
    device_brand_id!: number;
    /** The device brand name with 255 character limit */
    device_brand_name!: string;
    /** Manage status of device brand. 0 For De-active, 1 For Active */
    status!: number;
    /** The total model based on brand id */
    count!: number;

    constructor(data?: IDeviceBrandOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.device_brand_id = _data["device_brand_id"];
            this.device_brand_name = _data["device_brand_name"];
            this.status = _data["status"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): DeviceBrandOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceBrandOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["device_brand_id"] = this.device_brand_id;
        data["device_brand_name"] = this.device_brand_name;
        data["status"] = this.status;
        data["count"] = this.count;
        return data; 
    }
}

export interface IDeviceBrandOutputWithStatus {
    /** The auto-generated id of the device brand  master */
    device_brand_id: number;
    /** The device brand name with 255 character limit */
    device_brand_name: string;
    /** Manage status of device brand. 0 For De-active, 1 For Active */
    status: number;
    /** The total model based on brand id */
    count: number;
}

